jQuery( document ).ready( function() {
	jQuery( "#copy" ).on( "click" ,function( e ) {
		e.preventDefault();
		var button = jQuery( this );
		var shortcode = jQuery( "#shortcode" );
		button.attr( "disabled", true );
		shortcode.select();
		try {
			document.execCommand( "copy" );
			setTimeout(function(){
				button.removeAttr( "disabled" ).val( "Copy" );
			}, 1000);
			button.val( "Copied" );
		} catch( e ) {
		  button.val( "Error!" );
		  alert( "There was an error copying the shortcode. You will need to do it manually." );
		}
	});
});
